import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactUs from '../components/ContactUs';

const ContactUsPage = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <ContactUs />
      </main>
      <Footer />
    </div>
  );
};

export default ContactUsPage;

